/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://cq774hw7ibhjjjk2itauaqa534.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:0dca213f-8b42-4f5e-b555-a8422ec40a51",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_4dDM0ld0u",
    "aws_user_pools_web_client_id": "7dvubf283evbccvfait7730nd4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "usermanagementapp77d9772bf1d342f3ae4f49e33ca74092603-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
